import {Store} from 'redux';

import {AppState} from '../../store/appState';
import {getBadgeValue} from '../../store/data/preferences/countersSelectors';
import {electron} from './electron';
import {updateBadge} from './electronBridgeOutbound';

/** Subscribe to state changes to update the electron app if needed. */
export function maybeSetupElectronSubscription(store: Store<AppState>) {
  if (!electron) {
    return;
  }

  store.subscribe(() => {
    const state = store.getState();
    handleBadgeChange(state);
  });
}

/*
 * Application icon badge.
 */

let lastBadgeValue = 0;
function handleBadgeChange(state: AppState) {
  // Compute the current badge value.
  const badgeValue = getBadgeValue(state);
  if (!electron || badgeValue === lastBadgeValue) {
    return;
  }

  lastBadgeValue = badgeValue;
  const badge = lastBadgeValue !== 0 ? String(lastBadgeValue) : '';

  // Standalone app.
  updateBadge(badge);
}
